module.exports = __webpack_public_path__ + "img/Christensen.16ce9041.png";